import React, { useState } from 'react';
import Button from '@mui/material/Button';
import SuiTypography from '../../components/SuiTypography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { requestAddingBanner, requestUpdatingBanner } from '../../redux/actions/bannersActionCreators';

export default function BannerModal({ open, handleClose, isUpdating, initialValues, id, previewUrl }) {
  const dispatch = useDispatch();
  const [imageFile, setImageFile] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: Yup.object({
      productLink: Yup.string().required('Ce champ est obligatoire!'),
      order: Yup.number().required('Ce champ est obligatoire!'),
    }),
    onSubmit: (values, { resetForm }) => {
      if (isUpdating) {
        dispatch(
          requestUpdatingBanner(id, {
            imageFile,
            productLink: values.productLink,
            order: values.order,
            isActive: values.isActive,
          })
        );
      } else {
        dispatch(
          requestAddingBanner({
            imageFile,
            productLink: values.productLink,
            order: values.order,
            isActive: values.isActive,
          })
        );
      }
      resetForm();
      setImageFile(null);
      handleClose();
    },
  });

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" PaperProps={{ sx: { width: '80%' } }}>
      {isUpdating ? (
        <DialogTitle>Modification d'une bannière</DialogTitle>
      ) : (
        <DialogTitle>Ajout d'une bannière</DialogTitle>
      )}
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <Stack spacing={2}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Image
                </SuiTypography>
                {previewUrl && !imageFile && (
                  <img src={previewUrl} alt="" style={{ width: '100%', maxHeight: 120, objectFit: 'cover' }} />
                )}
                <input
                  type="file"
                  accept=".jpg,.jpeg,.png,.webp"
                  onChange={(e) => setImageFile(e.target.files[0])}
                />
              </Stack>
            </Grid>
            <Grid item xs={4}>
              <Stack spacing={2}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Lien produit
                </SuiTypography>
                <TextField
                  type="text"
                  placeholder="https://izy.tn/produit/..."
                  name="productLink"
                  error={Boolean(formik.touched.productLink && formik.errors.productLink)}
                  helperText={formik.touched.productLink && formik.errors.productLink}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.productLink}
                />
              </Stack>
            </Grid>
            <Grid item xs={2}>
              <Stack spacing={2}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Ordre
                </SuiTypography>
                <TextField
                  type="number"
                  name="order"
                  error={Boolean(formik.touched.order && formik.errors.order)}
                  helperText={formik.touched.order && formik.errors.order}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.order}
                />
              </Stack>
            </Grid>
            <Grid item xs={2}>
              <Stack spacing={2}>
                <SuiTypography component="label" variant="caption" fontWeight="bold">
                  Active
                </SuiTypography>
                <Switch
                  checked={formik.values.isActive}
                  onChange={(e) => formik.setFieldValue('isActive', e.target.checked)}
                />
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annuler</Button>
          {isUpdating ? (
            <Button type="submit">Modifier</Button>
          ) : (
            <Button type="submit">Ajouter</Button>
          )}
        </DialogActions>
      </form>
    </Dialog>
  );
}
